export const API_URL =
  "https://slapshot-session-tracker-api-1.onrender.com";